import { MenuProps} from "antd";

export const renderMenu = (items: MenuProps["items"]) => {
  return items?.filter((item: any) => !item.disabled);
}